import React from 'react';
import ReactDOM from 'react-dom';
import FormModal from '../FormModal.jsx';
import SignInFormContainer from '../../containers/auth/SignInFormContainer.jsx';

const validate = (values) => {
  const errors = {};
  if (!values.email) errors.email = 'Email is required';
  if (!values.password) errors.password = 'Password is required';
  return errors;
};

const SessionExpiredModal = ({ show, onSignIn }) => (
  <>
    {show &&
      ReactDOM.createPortal(
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            zIndex: 1059,
          }}
        />,
        document.body
      )}
    <FormModal
      show={show}
      hideFooter
      onHide={() => {}}
      resourceName="session"
      title="Your session has expired. Sign in to continue where you left off."
      createResource={onSignIn}
      validate={validate}
      closeButton={false}
      modalSize="sm"
      isInModal={true}
      className="session-expired-modal"
    >
      <div>
        <SignInFormContainer isInModal={true} onSuccess={onSignIn} />
      </div>
    </FormModal>
  </>
);

export default SessionExpiredModal;
